import { useEffect, useRef, useState } from "react";
import { useNavigate} from "react-router-dom";
import LoadingComponent from "../others/LoadingComponent";

const LandingHeader = () => {
  const link = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // form animation :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const [selectedAC , setSelectedAc] = useState(false)

  const [isVisible, setIsVisible] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0 }
    );

    if (formRef.current) {
      observer.observe(formRef.current);
    }

    return () => {
      if (formRef.current) {
        observer.unobserve(formRef.current);
      }
    };
  }, []);

  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  //----------------------form  --------------------

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [data, setData] = useState({
    acType: "",
    serviceName:[{serviceSummary:""}],
    name: "",
    phone: "",
    brand: "",
    serviceRequired: "",
    serviceDate: "",
    serviceTime: "",
    address: "",
    NoOfAc:"",
    formType: "Website",
  });

  const handleChange = (e) => {
    const value = e.target.value;
    setError(null)
    setData({
      ...data,
      [e.target.name]: value,
    });

      if (e.target.name === 'serviceRequired' && value !== '') {
      setSelectedAc(true);
      // alert("true")
      // console.log(e.target.name)
    }
   
  };

  const handleAcTypeChange = (e) => {
    setData({
      ...data,
      acType: e.target.value,
      serviceRequired: "",
    });
  };

  const handleNumber = (e) => {
    const value = e.target.value;
    setError(null);

    if (value.length <= 10) {
      setData({
        ...data,
        phone: value,
      });
    }
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    setData({
      ...data,
      serviceDate: value,
      serviceTime: "",
    });
  };

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const today = new Date().toISOString().split("T")[0];

  const timeSlots = [
    { value: "8:00am-10:00am", hour: 8 },
    { value: "10:00am-12:00pm", hour: 10 },
    { value: "12:00pm-2:00pm", hour: 12 },
    { value: "2:00pm-4:00pm", hour: 14 },
    { value: "4:00pm-6:00pm", hour: 16 },
    { value: "6:00pm-8:00pm", hour: 18 },
  ];

  const getFilteredTimeSlots = () => {
    if (data.serviceDate !== today) return timeSlots;
    const currentHour = new Date().getHours();
    return timeSlots.filter((slot) => slot.hour > currentHour);
  };

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const [userAgent, setUserAgent] = useState("");
  const [ipAddress, setIpAddress] = useState(null);

  const getIp = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");

      if (response.ok) {
        const res = await response.json();
        setIpAddress(res.ip);
      } else {
        console.log(false);
      }
    } catch (error) {
      console.log("error in getting few details");
    }
  };

  useEffect(() => {
    getIp();
    setUserAgent(navigator.userAgent);
  }, []);

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  const pageFullUrl = window.location.href;

  const updatedData = {
    remoteIP: ipAddress,
    userAgent: userAgent,
    formUrl: pageFullUrl,
  };

  const navigate = useNavigate();

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(data)
    setLoading(true);

    if (data.phone.length === 10) {
      const filledDate = localStorage.getItem("formFilledDate");
      const today = getTodayDate();
      if (filledDate === today) {
        // alert("You've already filled out the form. Please try calling us now.");
        setError(
          "You've already filled out the form. Please try calling us now."
        );
      } else {
        try {
          const response = await fetch(
             `${link}/booking-form/`,
            // "http://localhost:7007/booking-form/",

            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: apiKey,
              },
              body: JSON.stringify({ ...data, ...updatedData }),
            }
          );

          console.log(data);

          if (response.ok) {
            localStorage.setItem("formFilledDate", today);
            navigate("/thank-you");
          } else {
            const res_data = await response.json();

            setError(res_data.message);
          }
        } catch (error) {
          setError("Server Error");
        }
      }
    } else {
      setError("enter the valid number");
    }

    setLoading(false);
  };

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  return (
    <div>
       <div id="book-now"></div>

{loading?
      <LoadingComponent />
      :""
}
      
      <div className="landing-header">
        <div className="landing-header-main">
          <div className="landing-header-content">
            <div className="landing-header-content-text">
              <div className="landing-header-content-text-heading-1">
                We Provide Trusted AC Services & Repair
              </div>

              <div className="landing-header-content-text-heading-2">
                Sit back, relax and let us take care <br/>of your AC servicing
              </div>

              <div className="home-header-earn">
                {/* <div>Reffer & Earn</div>
                <i class="fa-solid fa-gift"></i>
                <span>Earn 50 rupees for each successful referral.</span> */}


<a href="#book-now">
                <div className="landing-header-book-bt-call-btn-home">
                  Book Service Now
                </div>
                </a>
              </div>

              {/* <div className="landing-header-content-text-images">
          <Link to="https://play.google.com/store/apps/details?id=com.repairbuddyapp" target="_blank" ><img className="footer-app" src={ps}  /></Link>
          <Link to="https://play.google.com/store/apps/details?id=com.repairbuddyapp" target="_blank" ><img className="footer-app" src={as}  /></Link>
          </div> */}
            </div>
            {/* <div className="landing-header-content-form"> */}
            <div>
              {/* <div id="book-now"></div> */} 
              {/* Old Jump Link */}

              <div
                className={`landing-header-content-form ${
                  isVisible ? "home-header-form-animate" : ""
                }`}
              >
                <form onSubmit={handleSubmit}>
                  <div className="landing-header-content-form-heading">
                    {/* Book Service For Your AC! */}
                    Book Professional Work  <br></br>
                    For Your AC Now!
                  </div>


                  {/* Ac type heading */}
                  
                  <div className="landing-header-content-form-type">
                    {/* <div>
                      <input
                        required
                        onChange={handleAcTypeChange}
                        type="radio"
                        name="acType"
                        value="Windows AC"
                        id="windows"
                      />{" "}
                      <label htmlFor="windows">Windows AC</label>
                    </div>

                    <div>
                      <input
                        required
                        onChange={handleAcTypeChange}
                        type="radio"
                        name="acType"
                        value="Split AC"
                        id="split"
                      />{" "}
                      <label htmlFor="split">Split AC</label>
                    </div> */}

                    {/* <div>
                      <input
                        required
                        onChange={handleAcTypeChange}
                        type="radio"
                        name="acType"
                        value="Cassette AC"
                        id="Cassette"
                      />{" "}
                      <label htmlFor="Cassette">Cassette AC</label>
                    </div> */}
                    
                  </div>

  {/* <div id="book-now"></div> */}
                  <div className="landing-header-content-form-row">
                    <input
                      required
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Your Name"
                      name="name"
                      id=""
                    />
                    <input
                      required
                      onChange={handleNumber}
                      type="number"
                      placeholder="Enter Your Number "
                      name="phone"
                      value={data.phone}
                      id=""
                    />
                  </div>

                  {/* <input required onChange={handleChange}  type="text" placeholder="Enter Brand " name="brand" value={data.brand} id="" /> */}
{/* 
                  <select required onChange={handleChange} name="brand">
                    <option value="" selected disabled>
                      ---Select Brand---
                    </option>
                    <option value="Voltas">Voltas</option>
                    <option value="Daikin">Daikin</option>
                    <option value="Blue Star">Blue Star</option>
                    <option value="Godrej">Godrej</option>
                    <option value="O General">O General</option>
                    <option value="Lloyd">Lloyd</option>
                    <option value="Carrier">Carrier</option>
                    <option value="LG">LG</option>
                    <option value="Samsung">Samsung</option>
                    <option value="Haier">Haier</option>
                    <option value="Toshiba">Toshiba</option>
                    <option value="Croma AC">Croma AC</option>
                    <option value="Hitachi">Hitachi</option>
                    <option value="Panasonic">Panasonic</option>
                    <option value="Whirlpool">Whirlpool</option>
                    <option value="Napoleon">Napoleon</option>
                    <option value="MarQ">MarQ</option>
                    <option value="Electrolux">Electrolux</option>
                    <option value="Vise AC">Vise AC</option>

                    <option value="Mitsubishi Electric">
                      Mitsubishi Electric
                    </option>
                    <option value="Other Brand">Other Brand</option>
                  </select> */}

                  {/* <div className="landing-header-content-form-row">
                    <div>
                      <label>Service Date:</label>
                      <input
                        required
                        type="date"
                        placeholder="*Service Date"
                        min={today}
                        onChange={handleDateChange}
                        value={data.serviceDate}
                        name="serviceDate"
                      />
                    </div>
                    <div>
                      <label>Service Time:</label>
                      <select
                        required
                        onChange={handleChange}
                        value={data.serviceTime}
                        name="serviceTime"
                      >
                        <option value="" disabled selected>
                          --Select Time--
                        </option>
                        {getFilteredTimeSlots().map((slot) => (
                          <option key={slot.value} value={slot.value}>
                            {slot.value}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div> */}

                  {/* <input
                    required
                    onChange={handleChange}
                    type="text"
                    placeholder="Service Required "
                    name="serviceRequired"
                    id=""
                  /> */}

                  {/* {data.acType ? (
                    <select
                      value={data.serviceRequired}
                      onChange={handleChange}
                      required
                      name="serviceRequired"
                    >
                      <option value="" selected disabled>
                        ----select service----
                      </option>

                      {data.acType === "Windows AC" ? (
                        <>
                          <option value="AC Jet Service - ₹ 599">
                            AC Jet Service - ₹ 499
                          </option>
                          <option value="AC Repair - ₹ 499">
                            AC Repair - ₹ 399
                          </option>
                          <option value="AC Gas Refilling - ₹ 1,999">
                            AC Gas Refilling - ₹ 1,999
                          </option>
                          <option value="AC Installation - ₹ 999">
                            AC Installation - ₹ 999
                          </option>
                          <option value="AC Shifting - ₹ 1,299">
                            AC Shifting - ₹ 1,299
                          </option>
                        </>
                      ) : data.acType === "Split AC" ? (
                        <>
                          <option value="AC Jet Service - ₹ 599">
                            AC Jet Service - ₹ 599
                          </option>
                          <option value="AC Repair - ₹ 499">
                            AC Repair - ₹ 499
                          </option>
                          <option value="AC Gas Refilling - ₹ 2,499">
                            AC Gas Refilling - ₹ 2,499
                          </option>
                          <option value="AC Installation - ₹ 1,399">
                            AC Installation - ₹ 1,399
                          </option>
                          <option value="AC Shifting - ₹ 1,999">
                            AC Shifting - ₹ 1,999
                          </option>
                        </>
                      ) : data.acType === "Cassette AC" ? (
                        <>
                          <option value="Cassette AC Service Deep Cleaning - ₹ 999">
                            Cassette AC Service Deep Cleaning - ₹ 999
                          </option>
                          <option value="Cassette AC Repair - ₹ 599">
                            Cassette AC Repair - ₹ 599
                          </option>
                          <option value="Cassette AC Gas Refill (per ton) - ₹ 1,799">
                            Cassette AC Gas Refill (per ton) - ₹ 1,799
                          </option>
                          <option value="Cassette AC Installation - ₹ 2,499">
                            Cassette AC Installation - ₹ 2,499
                          </option>
                        </>
                      ) : (
                        ""
                      )}
                    </select>
                  ) : (
                    ""
                  )} */}




 <select
                      value={data.serviceRequired}
                      onChange={handleChange}
                      required
                      name="serviceRequired"
                    >
                      <option value="" selected disabled>
                        ----Select service----
                      </option>

                      <>
                          <option value="AC Jet Service">
                            AC Jet Service
                          </option>
                          <option value="AC Repair">
                            AC Repair
                          </option>
                          <option value="AC Gas Refilling ">
                            AC Gas Refilling
                          </option>
                          <option value="AC Installation ">
                            AC Installation
                          </option>
                          <option value="AC Shifting ">
                            AC Shifting 
                          </option>
                        </>

                    </select>

{
  selectedAC ?

<select value={data.NoOfAc} 
onChange={handleChange}
required
name="NoOfAc"
>

  <option value="" selected disabled>--Select Number of AC--</option>
    <option value="1" >1 </option>
    <option value="2" >2 </option>
    <option value="3" >3 </option>
    <option value="4" >4 </option>
    <option value="5" >5 </option>
    <option  value="More than 5" >More than 5</option>
</select>

  :""
}
                  

                  {/* <input required onChange={handleChange} type="text" placeholder="Enter Your Address " name="address" id="" /> */}

                  <input
                    required
                    name="address"
                    value={data.address}
                    onChange={handleChange}
                    placeholder="Enter Full Address"
                  />
                    {/* <option value="" selected disabled>
                      ---Select City---
                    </option>
                    <option value="Delhi">Delhi</option>
                    <option value="Noida">Noida</option>
                    <option value="Greater Noida">Greater Noida</option>
                    <option value="Ghaziabad">Ghaziabad</option>
                    <option value="Gurugram">Gurugram</option>
                    <option value="Faridabad">Faridabad</option>
                  </select> */}

                  {error ? (
                    <div className="landing-header-content-form-error">
                      {error}
                    </div>
                  ) : (
                    ""
                  )}

                  {loading ? (
                    <button
                      disabled
                      className="home-header-form-button-disable"
                    >
                      Book Service Now
                    </button>
                  ) : (
                    <button ref={formRef}>Book Service Now</button>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingHeader;
